import { createApi } from '@reduxjs/toolkit/query/react';
import { listaccountbalances, createAccountMaster, updateAccountMaster } from '../../graphql';
import { baseQuery } from '../baseQuery';

export const listAccountBalanceApi = createApi({
  reducerPath: 'listAccountBalance',
  baseQuery: baseQuery,
  tagTypes: ['listAccountBalance'],
  endpoints: (builder) => ({
    listAccountBalance: builder.query({
      query: () => ({ body: listaccountbalances }),
      keepUnusedDataFor: Infinity,
      refetchOnMountOrArgChange: true,
      providesTags: ['listAccountBalance', 'allaccounts'],
    }),
  }),
});

export const { useListAccountBalanceQuery } = listAccountBalanceApi;
